// Shared frontend constants.
export default class Constants {
    static readonly CSV_SEPARATOR = ";";
}
